import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import BackToTop from '../components/BackToTop';
import '../css/global.css';
import '../css/Recognition.css';

const RecognitionPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="recognition-page">
            <Header />

            <Banner
                backgroundImage="/wp-content/uploads/2016/02/IMG_2094.jpg"
                title="Recognition of Employees"
            />

            <section className="contentwrapper clearfix">
                <div className="content clearfix">
                    <div className="breadcrumbs">
                        <a href="/">Home</a> &gt; <span>Recognition of Employees</span>
                    </div>

                    <h1 data-aos="fade-right">Recognition of Employees</h1>

                    {/* Row 1 */}
                    <div className="vc_row wpb_row vc_row-fluid">
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-right">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element wow fadeInLeft">
                                        <div className="wpb_wrapper">
                                            <p>At the heart of our Human Resource strategy is the focus of building and ensuring organizational commitment among employees.  The Company maintains a development oriented performance evaluating system and recognizes employees who perform exceedingly well and who are committed to the organization.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-left">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_single_image wpb_content_element vc_align_center wow fadeInRight">
                                        <figure className="wpb_wrapper vc_figure">
                                            <a href="/wp-content/uploads/2016/02/IMG_2047.jpg" className="vc_single_image-wrapper vc_box_border_grey prettyphoto">
                                                <img
                                                    width="1200"
                                                    height="800"
                                                    src="/wp-content/uploads/2016/02/IMG_2047.jpg"
                                                    className="vc_single_image-img"
                                                    alt="Employee Recognition"
                                                />
                                            </a>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Row 2 */}
                    <div className="vc_row wpb_row vc_row-fluid" style={{ marginTop: "40px" }}>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-right">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_single_image wpb_content_element vc_align_center wow fadeInLeft">
                                        <figure className="wpb_wrapper vc_figure">
                                            <a href="/wp-content/uploads/2016/02/IMG_2071.jpg" className="vc_single_image-wrapper vc_box_border_grey prettyphoto">
                                                <img
                                                    width="1200"
                                                    height="800"
                                                    src="/wp-content/uploads/2016/02/IMG_2071.jpg"
                                                    className="vc_single_image-img"
                                                    alt="Awards Ceremony"
                                                />
                                            </a>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-left">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element wow fadeInRight">
                                        <div className="wpb_wrapper">
                                            <p>Deserving employees are honored with annual awards based on different performance and commitment measurement criteria that are translated into awards such as,</p>
                                            <ul className="recognition-list">
                                                <li data-aos="fade-right" data-aos-delay="100">The Best Safety Inspector</li>
                                                <li data-aos="fade-right" data-aos-delay="150">Best Employee of each Division</li>
                                                <li data-aos="fade-right" data-aos-delay="200">Best Division / Department</li>
                                                <li data-aos="fade-right" data-aos-delay="250">Best Employee Suggestions</li>
                                                <li data-aos="fade-right" data-aos-delay="300">Best Subcontractor Company</li>
                                                <li data-aos="fade-right" data-aos-delay="350">Best Social Worker</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Row 3 */}
                    <div className="vc_row wpb_row vc_row-fluid" style={{ marginTop: "40px" }}>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-right">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_text_column wpb_content_element wow fadeInLeft">
                                        <div className="wpb_wrapper">
                                            <p>These awards are offered based on impartial and unbiased evaluations guaranteeing equality and transparency, which further strengthens the harmonious employer-employee relations which have been built over the years through unbiased and proactive Human Resource interventions and non-discriminatory employment practices.</p>
                                            <p>Colombo Dockyard complies strictly with all rules, regulations and obligations laid down by the International Labour Organisation (ILO) and also regulations laid by the Ministry of Labour, in Sri Lanka.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpb_column vc_column_container vc_col-sm-6" data-aos="fade-left">
                            <div className="vc_column-inner">
                                <div className="wpb_wrapper">
                                    <div className="wpb_single_image wpb_content_element vc_align_center wow fadeInRight">
                                        <figure className="wpb_wrapper vc_figure">
                                            <a href="/wp-content/uploads/2016/02/IMG_2121.jpg" className="vc_single_image-wrapper vc_box_border_grey prettyphoto">
                                                <img
                                                    width="1200"
                                                    height="800"
                                                    src="/wp-content/uploads/2016/02/IMG_2121.jpg"
                                                    className="vc_single_image-img"
                                                    alt="Recognition Awards"
                                                />
                                            </a>
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <BackToTop />
        </div>
    );
};

export default RecognitionPage;
